module.exports = __webpack_public_path__ + "img/Ycafe.28c9815c.jpg";